'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import ActionRow from '~/components/layout/ActionRow';
import { NumberInput } from '~/components/primitives';
import CheckoutInfoCard from './checkout/CheckoutInfoCard';
import EmptyCartAlert from './EmptyCartAlert';
import { FaqDropdown } from './FaqDropdown';
import { Icon } from '~/components/primitives';
import { useI18n } from '~/features/i18n';
import { useQuery } from '@tanstack/react-query';
import useCartState from './useCartState';
import useQuotationCardFormState from './useQuotationCardFormState';
import { graphql } from '@funkey/types/graphql/gql';
import { api } from '~/modules';
import { CartItemCard, type CartItemType } from './CartItemCard';
import { Callout } from '~/components/primitives';
import { Skeleton } from '~/components/primitives/skeleton';
import { usePortalCtx, usePortalHREFs, usePortalRouter } from '~/features/global/portal';
import { Units } from '~/modules/units';
import { CACHED_PARTICIPANTS_FILTER, MAX_PARTICIPANTS } from '~/features/activities/search/client/context';
import type { ActivityPriceType } from '@funkey/constants';
import { useLocalStorageState } from '~/modules/browser/storage';
import { VariantLanguageInlineSelect, useVariantOptions, usePriceInfo } from './VariantLanguageInlineSelect';
import { CartOrWishlist_Layout } from './ui/shared.server';
import Checkout_StepsProvider from './checkout/CheckoutStepsProvider';
import { VATKindDisplay } from '~/features/portals/money';
import { StepProgressBar } from '../layout/Steps/client';
import Title from '~/components/utils/Title';
import type { CartItemsGrouped } from './shared';
import { Checkout_ContinueButton } from './checkout-continue-button';
import { PORTAL_RELATIVE_HREF_CHECKOUT } from './hooks';
export const Cart_Page: React.FC = _props => {
  const $ = _c(57);
  const i18n = useI18n();
  const portal = usePortalCtx();
  const portalRouter = usePortalRouter();
  const cartSDK = useCartState();
  let t0;
  if ($[0] !== cartSDK) {
    t0 = cartSDK.cartItemsGrouped_queryOptions();
    $[0] = cartSDK;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const cartItems = useQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Checkout_StepsProvider><StepProgressBar className="mb-8" /></Checkout_StepsProvider>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== i18n) {
    t2 = i18n._("Request a (or multiple) quotation(s).");
    $[3] = i18n;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <header>{t1}<Title as="h2" size="xl" weight="xbold" className="mb-6">{t2}</Title></header>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== i18n) {
    t4 = i18n._("Feel free to request a quote");
    $[7] = i18n;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== i18n) {
    t5 = i18n._("You will receive a quote with additional information about the activity within 24 hours.");
    $[9] = i18n;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== i18n) {
    t6 = i18n._("We take care of the booking of teambuilding activities for you.");
    $[11] = i18n;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== i18n) {
    t7 = i18n._("We have for every thing more than 400 original activities.");
    $[13] = i18n;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== i18n) {
    t8 = i18n._("We get the most out of your budget by dealing with our professional teambuilding partners.");
    $[15] = i18n;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = [t6, t7, t8];
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FaqDropdown source="cart_sidebar" className="mt-8" />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t9) {
    t11 = <CheckoutInfoCard className="mb-10 mt-6 lg:mt-0" title={t4} description={t5} checklist={t9}>{t10}</CheckoutInfoCard>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon name="gift" className="mr-2.5 text-salmon-500" />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== i18n) {
    t13 = i18n._("Do you have a gift voucher or Funkey Voucher?");
    $[27] = i18n;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <p className="text-sm font-bold leading-5 text-primary">{t13}</p>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== i18n) {
    t15 = i18n._("You can add that in the next step.");
    $[31] = i18n;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15) {
    t16 = <p className="text-sm font-normal text-blue-700">{t15}</p>;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t14 || $[36] !== t16) {
    t17 = <div className="flex items-center justify-center">{t12}<div>{t14}{t16}</div></div>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t11 || $[39] !== t17) {
    t18 = <>{t11}{t17}</>;
    $[38] = t11;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== portalRouter) {
    t19 = () => portalRouter.push(PORTAL_RELATIVE_HREF_CHECKOUT("info"));
    $[41] = portalRouter;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== i18n) {
    t20 = i18n._("cart.cta.next-step", undefined, {
      message: "Next step"
    });
    $[43] = i18n;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <ActionRow className="sticky bottom-2 z-2 flex justify-end bg-white"><Checkout_ContinueButton className="ml-auto w-full lg:w-auto" onSubmit={t19}>{t20}</Checkout_ContinueButton></ActionRow>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== cartItems.data || $[49] !== cartItems.isLoading || $[50] !== portal) {
    t22 = cartItems.isLoading ? <CartSkeleton cardClassName={portal.portal === "BIZZ" ? "border-gray-200" : "border-brown-200"} /> : !cartItems.data?.all.length ? <EmptyCartAlert /> : <Cart_TabContent cartItems={cartItems.data ?? null} />;
    $[48] = cartItems.data;
    $[49] = cartItems.isLoading;
    $[50] = portal;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t18 || $[53] !== t21 || $[54] !== t22 || $[55] !== t3) {
    t23 = <CartOrWishlist_Layout tab="cart" header={t3} aside={t18} footer={t21}>{t22}</CartOrWishlist_Layout>;
    $[52] = t18;
    $[53] = t21;
    $[54] = t22;
    $[55] = t3;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  return t23;
};
const Cart_TabContent: React.FC<{
  cartItems: CartItemsGrouped;
}> = props => {
  const $ = _c(32);
  const i18n = useI18n();
  const portal = usePortalCtx();
  const hrefs = usePortalHREFs();
  const participantsStorage = useLocalStorageState(CACHED_PARTICIPANTS_FILTER);
  const [participants, setParticipants] = useState(CACHED_PARTICIPANTS_FILTER.initialValue);
  let t0;
  let t1;
  if ($[0] !== participantsStorage.state) {
    t0 = () => {
      setParticipants(current => current === undefined ? current : participantsStorage.state);
    };
    t1 = [participantsStorage.state];
    $[0] = participantsStorage.state;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== participantsStorage) {
    t2 = value => {
      if (typeof value === "number" && Number.isFinite(value) && value >= 1) {
        const next = Math.min(Math.floor(value), MAX_PARTICIPANTS);
        setParticipants(next);
        participantsStorage.setState(next);
      } else {
        setParticipants(undefined);
        participantsStorage.store.clear();
      }
    };
    $[3] = participantsStorage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = t2;
  let t4;
  if ($[5] !== i18n) {
    t4 = i18n._("participants");
    $[5] = i18n;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== participants || $[8] !== t3 || $[9] !== t4) {
    t5 = <NumberInput value={participants} onChange={t3} min={1} max={MAX_PARTICIPANTS} integerOnly={true} compact={true} suffix={t4} className="w-48! flex-none!" />;
    $[7] = participants;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== participants || $[12] !== props.cartItems.available) {
    let t7;
    if ($[14] !== participants) {
      t7 = cartItem => <li key={cartItem.id} data-testid="cart-item-row"><CartItemCard item={cartItem} size="md" participants={participants}><CartItemInlineEdit cartItem={cartItem} participants={participants} /></CartItemCard></li>;
      $[14] = participants;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = props.cartItems.available.map(t7);
    $[11] = participants;
    $[12] = props.cartItems.available;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <ul className="mt-4 space-y-4" data-testid="cart-items-list">{t6}</ul>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== i18n || $[19] !== participants || $[20] !== portal || $[21] !== props.cartItems.unavailable) {
    t8 = props.cartItems.unavailable.length > 0 && <><div className="mb-4 mt-8 flex items-center gap-2 pt-6"><Icon name="info-circle" size="sm" className="text-orange-500" /><p className="text-sm font-bold text-primary">{i18n._("wishlist.unavailable-section.title_{bizzName}", {
            bizzName: portal.portal === "BIZZ" ? portal.bizz.name : ""
          }, {
            message: "Not available for {bizzName}"
          })}</p></div><ul className="space-y-4" data-testid="cart-items-list-unavailable">{props.cartItems.unavailable.map(cartItem_0 => <li key={cartItem_0.id} data-testid="cart-item-row"><CartItemCard item={cartItem_0} size="md" participants={participants}><CartItemInlineEdit cartItem={cartItem_0} participants={participants} /></CartItemCard></li>)}</ul></>;
    $[18] = i18n;
    $[19] = participants;
    $[20] = portal;
    $[21] = props.cartItems.unavailable;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== hrefs || $[24] !== i18n || $[25] !== props.cartItems.available.length) {
    t9 = props.cartItems.available.length <= 3 && <Callout className="mt-6" type="success" fill={true} title={i18n._("cart.add-more.title", undefined, {
      message: "Looking for more activities?"
    })} description={i18n._("cart.add-more.description", undefined, {
      message: "Browse our catalog and add more activities to your quote request."
    })} href={hrefs.PLP()} />;
    $[23] = hrefs;
    $[24] = i18n;
    $[25] = props.cartItems.available.length;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t5 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = <>{t5}{t7}{t8}{t9}</>;
    $[27] = t5;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
const CartItemInlineEdit: React.FC<{
  cartItem: CartItemType;
  participants?: number;
}> = props => {
  const i18n = useI18n();
  const updateCartItem = useCartState().useUpsertCartItemMutation();
  const formState = useQuotationCardFormState({
    variantId: props.cartItem.activityVariantId ?? undefined,
    languageId: props.cartItem.activityLanguageId ?? undefined
  });
  if (!props.cartItem.activityId) {
    throw new Error(`CartItem doesn't have an activity linked to it`);
  }
  const query = api.useGraphqlQuery(MODAL_DATA_QUERY, {
    activityID: props.cartItem.activityId
  });
  const variants = query.data?.activity?.activityVariants ?? [];
  const languages = query.data?.activity?.activityLanguages ?? [];
  const priceType: ActivityPriceType = query.data?.activity?.priceType ?? 'PER_PARTICIPANT';
  const handleVariantChange = async (value: string | number) => {
    const id = value === '' ? null : Number(value);
    formState.handleChange('variantId', Number.isFinite(id) ? id : null);
    const variantId = Number(value);
    const languageId = Number(formState.values.languageId ?? props.cartItem.activityLanguageId);
    if (!variantId || !languageId) return;
    await updateCartItem.mutateAsync({
      cartItemID: props.cartItem.id,
      variantId,
      languageId,
      boostAdId: props.cartItem.boostAdId
    });
  };
  const handleLanguageChange = async (value_0: string | number) => {
    const id_0 = value_0 === '' ? null : Number(value_0);
    formState.handleChange('languageId', Number.isFinite(id_0) ? id_0 : null);
    const variantId_0 = Number(formState.values.variantId ?? props.cartItem.activityVariantId);
    const languageId_0 = Number(value_0);
    if (!variantId_0 || !languageId_0) return;
    await updateCartItem.mutateAsync({
      cartItemID: props.cartItem.id,
      variantId: variantId_0,
      languageId: languageId_0,
      boostAdId: props.cartItem.boostAdId
    });
  };
  const singleVariant = variants.length === 1 ? variants[0]! : null;
  const singleLanguage = languages.length === 1 ? languages[0]! : null;
  const variantOptionsResult = useVariantOptions({
    variants,
    participants: props.participants,
    priceType
  });
  const selectedVariant = variants.find(v => String(v.id) === String(formState.values.variantId));
  const priceInfo = usePriceInfo({
    selectedVariant,
    participants: props.participants,
    priceType,
    shouldDisplayPrices: variantOptionsResult.shouldDisplayPrices
  });
  return <VariantLanguageInlineSelect id={`cart-${props.cartItem.id}`} isLoading={query.isLoading || updateCartItem.isPending} disabled={updateCartItem.isPending} variants={variants} singleVariant={singleVariant} singleVariantTooltip={i18n._('cart.single-variant', undefined, {
    message: 'This activity has only one variant'
  })} variantValue={formState.values.variantId != null ? String(formState.values.variantId) : undefined} variantOptions={variantOptionsResult.variantOptions} onVariantChange={handleVariantChange} languages={languages} singleLanguage={singleLanguage} singleLanguageTooltip={i18n._('cart.single-language', undefined, {
    message: 'This activity has only one language'
  })} languageValue={formState.values.languageId != null ? String(formState.values.languageId) : undefined} onLanguageChange={handleLanguageChange} className="min-h-9" priceSlot={variantOptionsResult.shouldDisplayPrices && priceInfo ? <span data-testid="cart-item-price" className="whitespace-nowrap text-sm text-primary">
                        <span className="font-bold">
                            {Units.formatEUR(priceInfo.total * 100, i18n.locale)}
                        </span>
                        <span className="ml-1 font-normal text-blue-500">
                            {i18n._('price.total-for-participants_{participants}', {
        participants: props.participants
      }, {
        message: 'for {participants} pers.'
      })}
                            {' · '}
                            <VATKindDisplay hideParentheses />
                        </span>
                    </span> : undefined} />;
};
const CartSkeleton: React.FC<{
  cardClassName: string;
}> = props => {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.cardClassName) {
    t0 = new Array(3).fill(null).map((_, i) => <li key={i} className={`flex gap-4 border-b py-5 ${props.cardClassName}`}><Skeleton className="aspect-4/3 w-16 min-w-16 rounded-lg sm:w-[6.25rem] sm:min-w-[6.25rem]" /><div className="flex-1 space-y-2"><Skeleton className="h-4 w-3/4" /><Skeleton className="h-3 w-1/2" /><Skeleton className="h-3 w-1/3" /></div></li>);
    $[0] = props.cardClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul>{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const MODAL_DATA_QUERY = graphql(`
    query editCartItemModalData($activityID: Int!) {
        activity(id: $activityID) {
            priceType
            activityVariants {
                id
                name
                duration
                startupCost
                extraCost
                extraCostPerCount
                priceRules {
                    price
                    participants
                    extraPrice
                }
            }
            activityLanguages {
                id
                name
            }
        }
    }
`);